function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81C784",
  d: "M4.98 2.665h16v10.492l-8.177 7.854-7.823-7.987z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M5 2h16v1H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M5 2h1v10H5zM20 2h1v8h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.42 5.852L1.08 9.2m14.354-6.65L12.924.6l-2.48 1.882m10.208 3.29l4.468 3.452M1.274 25.267V9.95l11.66 10.875 11.998-10.88v15.322z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.967 10.362a2.086 2.086 0 01-.587-.405l-.045-.045.035-.053.246-.37a.331.331 0 01.112-.105.296.296 0 01.15-.041c.063 0 .128.021.193.062.055.034.117.075.187.12.066.045.143.09.229.134a.95.95 0 00.21.077l.11-1.316a5.052 5.052 0 01-.401-.138 1.599 1.599 0 01-.425-.246 1.164 1.164 0 01-.311-.394 1.326 1.326 0 01-.118-.592 1.372 1.372 0 01.409-.966 1.59 1.59 0 01.486-.323c.175-.077.372-.124.591-.14l.03-.345a.307.307 0 01.086-.188.276.276 0 01.208-.087h.38l-.057.659c.208.04.39.104.547.193.172.097.322.206.45.329l.047.045-.036.054-.195.3a.476.476 0 01-.11.117.26.26 0 01-.154.047.352.352 0 01-.148-.038 4.675 4.675 0 01-.155-.077 3.489 3.489 0 00-.185-.088 1.126 1.126 0 00-.13-.048l-.1 1.201c.136.044.272.09.406.142.16.06.303.138.43.234.131.099.238.221.318.367.083.15.124.333.124.55 0 .213-.036.413-.106.6s-.174.353-.31.497c-.135.144-.301.26-.498.35-.18.08-.381.132-.605.155l-.034.416a.311.311 0 01-.085.185.273.273 0 01-.209.089h-.378l.059-.713a2.49 2.49 0 01-.661-.205zm1.759-.81a.614.614 0 00.155-.439.43.43 0 00-.036-.184.442.442 0 00-.105-.141.72.72 0 00-.169-.112 1.73 1.73 0 00-.13-.058l-.094 1.128c.165-.035.29-.1.379-.194zm-.95-3.021a.6.6 0 00-.183.117.41.41 0 00-.1.147.485.485 0 00-.032.177c0 .072.012.134.035.187a.456.456 0 00.101.144c.046.045.1.084.164.12a1.5 1.5 0 00.121.06l.084-1.008a.947.947 0 00-.19.056z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.997 13.3h10.04M8.903 14.669h8.25M10.803 16.037h4.575",
  stroke: "#371447",
  strokeWidth: 0.65
}));

function SvgBillPaymentsSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBillPaymentsSm;